"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_dom_1 = require("react-dom");

var styled_components_1 = __importDefault(require("styled-components"));

var Columns_1 = require("./Columns");

var Layout_1 = require("./Layout");

var layout_1 = require("../layout");

var AI2Banner_1 = require("./AI2Banner");

var Header =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header(props) {
    var _this = _super.call(this, props) || this;

    _this.container = null;
    _this.lastScrollY = 0;

    _this.onScroll = function () {
      // This implements logic that:
      //  1. If the user scrolls down the page, at all, the AI2 banner at the top is hidden.
      //  2. If the user scrolls up, at all, the AI2 banner becomes visible again.
      if (_this.banner.current !== null) {
        var distance = window.scrollY - _this.lastScrollY;
        _this.lastScrollY = window.scrollY;
        var isCollapsed = distance > 0;

        _this.setState({
          isCollapsed: isCollapsed
        });
      }
    };

    _this.state = {
      isCollapsed: false,
      currentHeaderHeight: 0
    };
    _this.banner = React.createRef();
    return _this;
  }

  Header.prototype.componentDidMount = function () {
    window.addEventListener('scroll', this.onScroll);

    if (this.container !== null) {
      var maybeNode = react_dom_1.findDOMNode(this.container);

      if (maybeNode instanceof HTMLElement) {
        var currentHeaderHeight = maybeNode.getBoundingClientRect().height;
        this.setState({
          currentHeaderHeight: currentHeaderHeight
        });
      }
    }
  };

  Header.prototype.componentWillUnmount = function () {
    window.removeEventListener('scroll', this.onScroll);
  };

  Header.prototype.getTopOffset = function () {
    if (!this.props.alwaysVisible && this.state.isCollapsed && this.banner.current !== null) {
      return -1 * (this.banner.current.getBoundingClientRect().height - parseFloat(window.getComputedStyle(this.banner.current).paddingBottom || '0'));
    }

    return 0;
  };

  Header.prototype.render = function () {
    var _this = this;

    return React.createElement(layout_1.LayoutContext.Consumer, null, function (_a) {
      var setHeaderHeight = _a.setHeaderHeight;

      var offset = _this.getTopOffset();

      setHeaderHeight(_this.state.currentHeaderHeight + offset);
      return React.createElement(Sticky, {
        ref: function ref(instance) {
          return _this.container = instance;
        },
        style: {
          top: offset + "px"
        }
      }, React.createElement(AI2Banner_1.AI2Banner, {
        ref: _this.banner
      }), React.createElement(HeaderContent, null, _this.props.children));
    });
  };

  return Header;
}(React.PureComponent);

exports.Header = Header;
var HeaderContent = styled_components_1["default"](Layout_1.Content)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n"], ["\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n"])));
var Sticky = styled_components_1["default"](Layout_1.LayoutHeader)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    && {\n        position: sticky;\n        top: 0;\n        background: white;\n        z-index: ", ";\n        width: 100%;\n        box-shadow: 0px 4px 16px rgba(10, 41, 57, 0.08);\n        height: initial; /* Ant sets a height, we need to unset that. */\n        padding: 0;\n        transition: top 200ms ease-in-out;\n    }\n"], ["\n    && {\n        position: sticky;\n        top: 0;\n        background: white;\n        z-index: ", ";\n        width: 100%;\n        box-shadow: 0px 4px 16px rgba(10, 41, 57, 0.08);\n        height: initial; /* Ant sets a height, we need to unset that. */\n        padding: 0;\n        transition: top 200ms ease-in-out;\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.zIndex.header;
});
exports.HeaderColumns = styled_components_1["default"](Columns_1.Columns)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    align-items: center;\n"], ["\n    width: 100%;\n    align-items: center;\n"])));
exports.HeaderTitle = styled_components_1["default"].h5(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    font-size: 1.9rem;\n    line-height: 1.65rem;\n    @media (max-width: ", ") {\n        font-size: 1.75rem;\n        line-height: 1.5rem;\n    }\n"], ["\n    margin: 0;\n    font-size: 1.9rem;\n    line-height: 1.65rem;\n    @media (max-width: ", ") {\n        font-size: 1.75rem;\n        line-height: 1.5rem;\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.breakpoints.xs;
});
exports.HeaderSubTitle = styled_components_1["default"](exports.HeaderTitle)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    text-transform: none;\n"], ["\n    text-transform: none;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;